import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2, XCircle } from 'lucide-react';
export function OfferSection() {
  return <section className="w-full px-4 py-8 md:py-12 max-w-2xl mx-auto" data-id="element-42">
      <FadeIn data-id="element-43">
        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-44">
          <div className="bg-[#7B9E6B]/10 p-4 md:p-6 rounded-xl" data-id="element-45">
            <h3 className="font-bold text-lg md:text-xl text-[#2D2A26] mb-3 md:mb-4 flex items-center" data-id="element-46">
              <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[#7B9E6B] mr-2 flex-shrink-0" data-id="element-47" />
              This is for you if:
            </h3>
            <ul className="space-y-2.5 md:space-y-3 text-[#2D2A26] text-[15px] md:text-base" data-id="element-48">
              <li className="flex items-start" data-id="element-49">You're 65+</li>
              <li className="flex items-start" data-id="element-50">
                <span className="mr-2" data-id="element-51">•</span> you feel unsteady, cautious, or
                "not like yourself" on your feet
              </li>
              <li className="flex items-start" data-id="element-52">
                <span className="mr-2" data-id="element-53">•</span> you want a safe plan you can do
                privately at home
              </li>
              <li className="flex items-start" data-id="element-54">
                <span className="mr-2" data-id="element-55">•</span> you want structure, not
                motivation
              </li>
            </ul>
          </div>

          <div className="bg-[#FF5A5F]/5 p-4 md:p-6 rounded-xl" data-id="element-56">
            <h3 className="font-bold text-lg md:text-xl text-[#2D2A26] mb-3 md:mb-4 flex items-center" data-id="element-57">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-[#FF5A5F] mr-2 flex-shrink-0" data-id="element-58" />
              This is NOT for you if:
            </h3>
            <ul className="space-y-2.5 md:space-y-3 text-[#2D2A26] text-[15px] md:text-base" data-id="element-59">
              <li className="flex items-start" data-id="element-60">
                <span className="mr-2" data-id="element-61">•</span> you have severe dizziness or
                blackouts
              </li>
              <li className="flex items-start" data-id="element-62">
                <span className="mr-2" data-id="element-63">•</span> you have a recent fracture or
                surgery
              </li>
              <li className="flex items-start" data-id="element-64">
                <span className="mr-2" data-id="element-65">•</span> you have symptoms that need
                clinician guidance first
              </li>
            </ul>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-66">
        <div id="purchase" className="bg-white rounded-2xl md:rounded-3xl shadow-xl border border-[#2D2A26]/5 overflow-hidden text-center p-5 md:p-12 mb-8 md:mb-12" data-id="element-67">
          <h3 className="text-lg md:text-xl font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-68">
            Why the price is low (on purpose)
          </h3>
          <p className="text-sm md:text-base text-[#2D2A26]/80 mb-6 md:mb-8 max-w-md mx-auto" data-id="element-69">
            This is meant to be an impulse-safe purchase: small enough to try
            immediately, valuable enough to keep using.
          </p>

          <div className="mb-6 md:mb-8" data-id="element-70">
            <div className="flex items-center justify-center gap-2.5 md:gap-3 mb-1" data-id="element-71">
              <span className="text-xl md:text-2xl text-[#2D2A26]/40 line-through font-serif" data-id="element-72">
                $19
              </span>
              <span className="bg-[#FF5A5F] text-white text-xs md:text-sm font-bold px-2.5 md:px-3 py-0.5 md:py-1 rounded-full" data-id="element-73">
                -66%
              </span>
            </div>
            <span className="text-5xl md:text-6xl font-bold text-[#2D2A26] font-serif" data-id="element-74">
              $6.39
            </span>
            <p className="text-sm md:text-base text-[#7B9E6B] font-medium mt-1.5 md:mt-2" data-id="element-75">
              Instant download. Print it, or use it on your phone.
            </p>
          </div>

          <Button fullWidth showArrow href="https://www.dailyfixtoolkit.com/cart/44192098091101:1" className="text-lg md:text-xl py-4 md:py-5 shadow-xl hover:shadow-2xl transform hover:-translate-y-1" data-id="element-76">
            Get the No-Fall Confidence Plan
          </Button>

          <p className="text-xs md:text-sm text-[#2D2A26]/50 mt-3 md:mt-4" data-id="element-77">
            Secure payment • Instant Access • 100% Money-back Guarantee
          </p>
        </div>
      </FadeIn>
    </section>;
}